<template>
  <div ref="commentNav" id="commentNav">
    <div class="comment_reply22">

      <div class="comment_reply_title_input"
        :class="[show_article_img  ? 'comment_reply_title_input_fixed' : '']"
        >

        <div class="comment_reply_title">
          <div class="comment_reply_title_left">
            <div :class=" 'comment_reply_title_item' ">
              <!-- 全部评论 -->
              共  
              <span class="comment_reply_title_num">{{this.num}}</span>
              条评论
            </div>
          </div>
          <div class="comment_reply_title_right">
            <div class="comment_reply_title_right_person"
              @click="srH5CallNativeMethodApp('call_Native',{
                kind: 'person_page',//跳转页面
                id:card_user.l_id,
                o_kind:'live_msg',
              })"
              v-if="show_stock">
            </div>
            <div class="comment_reply_sort" v-if="show_list">
              <button :class="{bindThis: checkTab == 'hot'}" @click.stop.prevent="checkTabFn('hot')">推荐</button>
              <button :class="{bindThis: checkTab == 'time'}" @click.stop.prevent="checkTabFn('time')">最新</button>
            </div>
          </div>
        </div>

        <div class="comment_reply22_input"
          @click.stop.prevent="
          srH5CallNativeMethodApp('comment_input',{
            kind:'detail',
            comment_marked_words:comment_tip,
          })"
        >
          <div class="comment_reply22_input_image" 
          :style="{
            'background-image': 'url(' + decodeURIComponent(user_avater)  + ')'
          }"
            ></div>
          <div class="comment_reply22_input_box">发表我的看法</div>
        </div>

      </div>

      <div class="comment_reply_title_input_empty" v-show="show_article_img">

      </div>

      <div class="dy_comsec22_no" v-if="!loading && list.length == 0">
        <img src="https://cdncos.aigupiao.com/assets/pc/img/2023/app_no_c.svg" alt="">
        <p v-if="commentable_self > 0">快来分享您的看法, 
          <span
            @click.stop.prevent="
            srH5CallNativeMethodApp('comment_input',{
              kind:'detail',
              comment_marked_words:comment_tip,
            })"
          >点击评论</span></p>
      </div>

      <ul class="dy_comsec22">
        <c-box
          :card_user="card_user"
          :id="content_id"
          :data="list"
          :ckind="c_kind"
          @ShowListData="ShowListData"
          :kind="content_kind"
          :teacher="teacher"
          :card_user_info="card_user_info"
          :apptextSize="apptextSize"
        ></c-box>
        <li v-if="loading" class="more2022 nodata">
          正在加载...
        </li>

        <li v-if="(nodata||!more) && list.length > 0" class="more2022 nodata">
          已显示全部数据
        </li>

      </ul>



    </div>

    <div class="comment_reply22_detail">
      <div class="comment_reply22_detail_input"
          @click.stop.prevent="
          srH5CallNativeMethodApp('comment_input',{
            kind:'detail',
            comment_marked_words:comment_tip,
          })"
        >
        {{ commentable_self ?'在这里发表评论…':'本条内容暂不支持评论'}}
      </div>

      <div class="comment_reply22_detail_right">
        <div class="right_comment" v-show="!show_article_img" @click="pagetop('comment')">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="18" viewBox="0 0 20 18" fill="none">
            <path d="M12.1118 14.3692H11.9059L11.7597 14.5141L9.96161 16.2972C9.9275 16.331 9.8725 16.331 9.83839 16.2972L8.04031 14.5141L7.89412 14.3692H7.68824H3.4375C2.09131 14.3692 1 13.2778 1 11.9317V3.54999C1 2.2038 2.09131 1.11249 3.4375 1.11249H16.3625C17.7087 1.11249 18.8 2.20379 18.8 3.54999V11.9317C18.8 13.2778 17.7087 14.3692 16.3625 14.3692H12.1118Z" stroke="#767676"/>
            <circle cx="5.1" cy="8" r="1" fill="#767676"/>
            <circle cx="9.8" cy="8" r="1" fill="#767676"/>
            <circle cx="14.5" cy="8" r="1" fill="#767676"/>
          </svg>
          <span v-if="this.num">{{this.num}}</span>
        </div>
        
        <div class="right_article" v-show="show_article_img" @click="pagetop">
          <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
            <path d="M5.51938 2.38821H19.4807C21.0606 2.38821 22.3414 3.669 22.3414 5.24894V18.751C22.3414 20.331 21.0606 21.6117 19.4807 21.6117H14.9537H10.0463H5.51938C3.93945 21.6117 2.65865 20.331 2.65865 18.751V5.24894C2.65865 3.669 3.93945 2.38821 5.51938 2.38821Z" stroke="#767676" stroke-width="1.17363"/>
            <path d="M7.42883 7.2384H16.5709" stroke="#767676" stroke-width="1.17363" stroke-linecap="round"/>
            <path d="M7.42883 11.9329H14.7384" stroke="#767676" stroke-width="1.17363" stroke-linecap="round"/>
            <path d="M7.42883 16.6274H17.5712" stroke="#767676" stroke-width="1.17363" stroke-linecap="round"/>
          </svg>
        </div>

        <div class="right_for"
           @click.stop.prevent="
            srH5CallNativeMethodApp('share',{data:card_user_info})"
          >
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="16" viewBox="0 0 18 16" fill="none">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M1 14.0131C1 11.835 2.56825 6.01071 10.3256 5.40767C10.3256 4.39555 10.3256 1.95879 10.3256 0.857264C10.3256 0.646422 10.578 0.539659 10.7309 0.684848L17.2324 6.85894C17.5442 7.15508 17.5575 7.64774 17.2622 7.9603L10.7401 14.8615C10.591 15.0193 10.3256 14.9137 10.3256 14.6966V10.0521C10.3256 10.0521 4.52786 10.0521 1.33466 14.0862C1.18103 14.2803 1 14.3635 1 14.0131Z" stroke="#767676"/>
          </svg>
        </div>

        <!-- vip消息不显示 -->
        <!-- <div class="right_s" 
          v-if="0 && card_user_info.stock_info && card_user_info.stock_info.length"
          @click.stop.prevent="
            srH5CallNativeMethodApp('detail_stock',{data:card_user_info.stock_info})"
          >
          $
          <span>{{card_user_info.stock_info && card_user_info.stock_info.length}}</span>
        </div> -->

      </div>



    </div>

  </div>
</template>

<script>
import { scrollLoad } from "@/utils/index";
import "@/utils/flexible";
import cBox from "./cBox.vue";
import userHomeApi from "@/api/user_home/index.js";
import { appversion,user_id,source,getQueryVariable } from "@/utils/urlQuery";
import { Dialog } from "vant";
export default {
  name: "comment-nav",
  components:{
    cBox,
  },
  data() {
    return {
      list:[],//内容的评论列表
      c_kind:'first',//评论框种类：此时为一级评论框
      num:0,
      loading:true,
      more:false,
      before:0,
      hot_page: 1,
      nodata:false,
      commentable_self:"1",//是否允许评论
      comment_tip:'',//评论提示由接口返回
      checkTab: "hot", // [time, hot]// 时间排序 、 热度排序
      discuss:[],//评论原文
      show_article_img:false,

      user_avater:getQueryVariable('user_avater'),//当前登录用户头像
      user_l_id:getQueryVariable('user_l_id') || 0,//当前登录用户l_id
      scroll_btm: this.$route.query.scroll_btm || 'no', // 定位

    };
  },
  props: {
    content_id:String,//内容id
    content_kind:String,//内容种类
    teacher:Boolean,//是否是老师自己的内容（可对所有进行删除 拉黑）
    card_user_info: {
      type: Object,
      default: ()=>({})
    }, // 页面信息
    card_user: {
      type: Object,
      default: ()=>({})
    }, // 页面用戶信息
    apptextSize:String,//改变字号
  },
  created() {
    this.getlist(1);
  },
  mounted(){

    this.srH5CallNativeMethodApp('get_logged_user_avatar');

    let _this = this;
    this.listenScrollFn();

    window.expandComment = function(){
      setTimeout(() => {
          $('.content_css').each(function(){
            if(!$(this).hasClass('expandCommentCss')){
              $(this).addClass('expandCommentCss');
              if($(this).height() > $('.content_css_less_line').height() * 6){
                $(this).addClass('content_css_less');
                $(this).children('.expand_full_js').show();
              }
            }
          });
      }, 10);
    }

    window.onscrollFn = function(){
      //标签浮动
      window.box_scroll = $('.comment_reply_title_input').offset().top ;
      $(window).scroll(function() {
        let scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
        console.log('box_scroll',window.box_scroll,'scrollTop',scrollTop);
        if(scrollTop >= window.box_scroll){ 
          //浮动于头部下面
          _this.show_article_img = true;
        }
        else{  
          //恢复位置
          _this.show_article_img = false;
        }
      })
    }

    this.$nextTick(() => {

      setTimeout(() => {

        window.onscrollFn();
        if(this.scroll_btm == 'yes') {
          this.pagetop('comment');
        }

      }, 600);

      

    })


  },
  methods: {
    srNativeCallH5Method(data) {
      let params = null;
      params = this.handleSpecialCharacters(data);
      if(params.method_name == 'comment_add') {
        let {i,j,data,replied_user} = params.params;
        data = {
          "id": data.commen_id,
          "u_id": user_id,
          "l_id": this.user_l_id,
          "u_name": data.share_msg.nickname,
          "role": data.share_msg.role,
          "u_avatar": data.share_msg.avatar,
          "support_num": 0,
          "content": data.share_msg.content,
          "image": data.share_msg.image,
          "rec_time_desc":data.share_msg.rec_time_desc,
          "is_support":'no',
        };
        if(i >= 0){
          //回复评论
          if(j >= 0){
            //回复二级评论
            data = {
              "r_name":replied_user.u_name,
              "r_id":replied_user.u_name,
              "r_l_id":replied_user.l_idm,
              "is_vip_service": replied_user.is_vip_service,
              ...data,
            };
          }
          this.addSecond({i,j,data});
        }
        else{
          //回复内容
          data = {
            comment_num:0,
            "sub_list":[],
            ...data,
          };
          //app增加评论一级评论数据
          this.addFirst(data);
        }
      }
      else if(params.method_name == 'comment_del') {
        //app删除评论数据
        let {i,j,comment_num,comment_id} = params.params;
        this.removeSelf({i,j,comment_num,comment_id});
      }
      else if(params.method_name == 'give_logged_user_avatar'){
        if(params.params.kind == "url"){
          this.user_avater = params.params.url;
        }
        else if(params.params.kind == "base64"){
          this.user_avater = 'data:image/png;base64,'+params.params.url;
        }
      }
	  // 下拉刷新
	  else if(params.method_name == "reload_page_list") {
	      // 更新数据
	      this.checkTabFn(this.checkTab, 'close')
	  }
    },
    handleSpecialCharacters(jsonStr) {
        let obj = {};
        if (jsonStr && Object.prototype.toString.call(jsonStr) == "[object String]" && jsonStr != 'null') {
            jsonStr = jsonStr.replace(/\n/g, "\<br/>");
            obj = JSON.parse(jsonStr)
        }
        return obj;
    },
    pagetop(kind){
      
      this.$nextTick(() => {
        window.box_scroll = $('.comment_reply_title_input').offset().top ;

        if(kind == 'comment'){
          window.scroll(0, box_scroll+1);
        }
        else{
          window.scroll(0, 0);
        }
      })
      
    },
    srH5CallNativeMethodApp(kind,other){
      this.$srH5CallNativeMethodApp(kind,{
        ...other
      })
    },
    async columnListMore() {
      if (this.loading || this.nodata || !this.more) {
        return;
      }
      await this.getlist();
    },
    listenScrollFn() {
      window.document.addEventListener(
          "scroll",
          scrollLoad(this.columnListMore),
          false
      );
    },
    checkTabFn(type, is_close){
      this.checkTab = type;
      this.before = 0;
      this.hot_page = 1;
      this.list = [];
      this.more = true;
      this.nodata = false;
      // 请求对应的列表
      this.getlist(1, is_close)
    },
    async getlist(is_first, is_close) {
      let _this = this;
      _this.loading = true;
      _this.more = false;
      let data = {
        appversion: appversion,
        source:source,
        u_id:user_id,
        user_id:user_id,
        kind:this.content_kind,

        id:this.content_id,
        before:this.before,
        web_data:'yes', 
        division:1,
        order:'desc'
      };
      if(this.checkTab == 'hot') {
        data.order_by_field = 'hot'
        data.hot_page = this.hot_page;
      }
      let res = await userHomeApi.getComment(data);

      _this.loading = false;
      console.log(res)
      if(res.rslt == "succ"){

        if(is_first == 1){
          _this.comment_tip = res.comment_marked_words;
          //第一次加载
          console.log(res.comment_list)
          _this.discuss = res.discuss;
          _this.list = _this.listData(res.comment_list) ;
          _this.num = res.comment_num;
        }
        else{
          console.log('加载更多')
          //加载更多
          _this.list = [..._this.list,..._this.listData(res.comment_list)];
        }

        if(_this.checkTab == 'hot') {
          _this.hot_page+=1;
        }
        
        //判断还有没有更多
        _this.before = res.before;

        //总数量>10 并且有更多 ，才会有加载更多
        if(_this.num > 10 && _this.before > 0 ){ 
          _this.more = true;
        }
        
        //总数量为0 或者  没有更多数据时 
        if(_this.num == 0 || _this.before <= 0){
          _this.nodata = true;
        }

        //不允许评论
        if(res.commentable == '0' || _this.commentable == '0'){
          _this.commentable_self = '0';
        }


        _this.$nextTick(function () {
          //展开更多
          window.expandComment();
        });
        
      }
	  
	  if(is_close == 'close') {
		  _this.$srH5CallNativeMethodApp('refresh_done',{})
	  }

    },
    addFirst(data){
      this.list.unshift(data);
      this.num++;
    },
    addSecond(res){
      let data = res.data,i = res.i,j = res.j;
      if(j >= 0){
        console.log('添加二级评论的评论');
        this.list[j].sub_list.splice(i+1,0,data);
        this.list[j].comment_num++;
      }
      else{
        console.log('添加二级评论');
        //console.log(i,this.list[i],this.list[i].sub_list)
        this.list[i].sub_list.unshift(data);
        if(this.list[i].comment_num === undefined){
          //开始没有二级评论
          this.list[i].comment_num = 1;
        }
        else{
          this.list[i].comment_num++;
        }
        
      }
      this.num++;
    },
    removeSelf(data){
      // {
      //   i://一级评论数组下标
      //   j://二级评论数组下标
      //   comment_num://一级评论子评论数量
      // }
      let ci = data.j,i = data.i,comment_num = data.comment_num,
          comment_id = data.comment_id;
      if(ci >= 0){
        if(this.list[ci].sub_list[i].id != comment_id){
          //判断是否删除的评论id
          return false;
        }
        //删除二级评论
        console.log('删除自己的二级评论');
        this.list[ci].sub_list.splice(i,1);
        this.list[ci].comment_num--; 
        this.num--;
        console.log('ShowListData 前',this.list[ci])
        this.ShowListData(ci);
        this.list[ci].old_comment_num = this.list[ci].comment_num;

        
        let _id = this.list[ci].id;
        setTimeout(() => {
          this.$nextTick(()=>{
              let len = $(`#erji_shouqi${_id} .dy_secItem22`).length;
              if(len >= 3){
                for(let i = 1;i<=3;i++){
                  $(`#erji_shouqi${_id} .dy_secItem22:nth-child(${i})`).show();
                }
              }
            })
        }, 10);
      }
      else{
        if(this.list[i].id != comment_id){
          //判断是否删除的评论id
          return false;
        }
        //删除一级评论  会连带把子评论删除掉 所以多减去子评论的数量
        console.log('删除自己的一级评论');
        this.list.splice(i,1);
        this.num = this.num - 1 - comment_num;
      }
    },
    listData(res){
      //获取本地点赞状态
      for(let item of res){
        if(localStorage['comment'+item.id] == 'yes'){
          item.is_support = "yes";
        }
        else{
          item.is_support = "no";
        }
        console.log(item)
        //原评论数量
        item.old_comment_num = item.comment_num;
        if(item.sub_list.length > 0){
          for(let i in item.sub_list){
            item.sub_list[i].old_i = i;
            if(localStorage['comment'+item.sub_list[i].id] == 'yes'){
              item.sub_list[i].is_support = "yes";
            }
            else{
              item.sub_list[i].is_support = "no";
            }
          }
        }
      }
      return res;
    },
    ShowListData(j){
      console.log('ShowListData')
      //收起时处理数据
      let new_sub_list = this.list[j].sub_list;
      for(let i in new_sub_list){
        new_sub_list[i].old_i = i;
      }
      console.log('new_sub_list',new_sub_list)
      this.$set(this.list,j,{
        ...this.list[j],
        sub_list:new_sub_list,
      })
      console.log('ShowListData 后',this.list[j].sub_list)
    }

  },
  computed: {
    show_stock(){
      // if(this.card_user && this.card_user.offer_qa == 'yes'){
      //   if(this.card_user && this.card_user.is_zh !=  "yes"){
      //     return true;
      //   }
      // }
      return false;
    },
    show_list(){
      if(!this.show_stock && (this.num > 15)){
        return true;
      }
      return false;
    }
  }
};
</script>

<style scoped lang="scss">
  @import "~@/assets/sass/global.scss";
  .comment_reply22{
    background: $a-white;
    padding: 0 rem2(12px) rem2(48px);

    
    .comment_reply_title_input{
      padding-bottom:rem2(5px);
    }

    .comment_reply_title_input_fixed{
      position: fixed;
      width: 100vw;
      background: $a-white;
      z-index: 1;
      top: 0;
      left: 0;
      padding: 0 rem2(12px) rem2(5px);
      box-sizing: border-box;
    }

    .comment_reply_title_input_empty{
      height: rem2(80px);
    }

    .comment_reply_title {
      height: rem2(40px);
      font-size: rem2(14px);
      font-weight: 600;
      color: #939393;
      align-items: center;
      display: flex;
      justify-content: space-between;
      .comment_reply_title_left {
        display: flex;

        >div{
          cursor: pointer;
        }
      }

      .comment_reply_title_right {
        display: flex;
        align-items: center;

        .comment_reply_title_right_person{
          width: 200px;
          height: 20px;
          flex-shrink: 0;
          background: url(https://cdncos.aigupiao.com/assets/pc/img/2023/app_c_q.svg) no-repeat;
          background-size: contain;
          background-position: right;
        }

        .comment_reply_sort {
          
          display: flex;
          align-items: center;

          button {
            font-size: rem2(14px);
            color: #636363;
            font-weight: normal;
            background-color: transparent;
            border: none;
            outline: none;
            cursor: pointer;

            &.bindThis {
              color: $a-normal;
            }

            &:first-child {
              padding-left: 0;
              margin-right: rem2(12px);
              position: relative;
            }
          }
        }
      }
      
    }

    .comment_reply22_input{
      display: flex;
      align-items: center;
      justify-content: space-between;
      .comment_reply22_input_image{
        width: rem2(32px);
        height: rem2(32px);
        flex-shrink: 0;
        border-radius: rem2(32px);
        background: url(<path-to-image>) lightgray 50% / cover no-repeat;
        margin-right: rem2(10px);
      }
      .comment_reply22_input_box{
        flex: 1;
        height: rem2(35px);
        border-radius: rem2(18px);
        background: $a-grey-f6;
        color: #B1B1B1;
        font-size: rem2(14px);
        display: flex;
        align-items: center;
        padding-left: rem2(17px);
        box-sizing: border-box;
      }
    }
    .dy_comsec22{

      .more2022{
        position: relative;
        display: flex;
        justify-content: center;
        font-size: rem2(14px);
        line-height: rem2(30px);
        color: #707070;
      }

    }

    .dy_comsec22_no{
      height: rem2(200px);
      font-size: rem2(13px);
      color: #939393;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      span{
        color: #1D88D0;
      }
      img{
        width: rem2(75px);
        height: rem2(75px);
        flex-shrink: 0;
        margin-bottom: rem2(12px);
      }
    }

  }

  .comment_reply22_detail{
    position: fixed;
    bottom: 0;
    width: 100vw;
    border-top: rem2(1px) solid $a-bordr-c;
    background: $a-white;
    display: flex;
    justify-content: space-between;
    .comment_reply22_detail_input{
      //width: rem2(222.5px);
      flex: 1;
      height: rem2(38px);
      flex-shrink: 0;
      margin: rem2(5px) rem2(9.5px);
      background: $a-grey-b2;
      border-radius: rem2(5px);
      display: flex;
      align-items: center;
      padding-left: rem2(11px);
      box-sizing: border-box;
      color: #939393;
      font-size: rem2(15px);

    }

    .comment_reply22_detail_right{
      display: flex;
      align-items: center;
      margin-left: 20px;
      >div{
        margin-right: 20px;
      }
      .right_comment{
        position: relative;
        svg{
          width: 18.8px;
          height: 16.45px;
          flex-shrink: 0;
        }
        span{
          position: absolute;
          right: -6px;
          top: -6px;
          border-radius: 6px;
          background: #FE484A;
          color: $a-white;
          font-size: 9px;
          padding: .5px 3.5px ;
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }
      .right_article{
        svg{
          width: 18px;
          height: 18px;
          flex-shrink: 0;
        }
      }
      .right_for{
        svg{
          width: 16.797px;
          height: 15px;
          flex-shrink: 0;
        }

      }
      .right_s{
        position: relative;
        color: #767676;
        font-size: 20.5px;
        font-style: normal;
        font-weight: 300;
        line-height: normal;
        span{
          position: absolute;
          right: -5px;
          top: -3px;
          font-size: 9px;
        }
      }





    }
  }

</style>
<style>
  a{
    text-decoration: none;
  }
  ul {
    list-style-type: none;
  }
  *{ margin:0; padding:0; }
  /* AGP_fac適配？？ */
  .dy_comsec22 .AGP_face {
    width: 18px;
    height: 18px;
    vertical-align:sub;
  }

</style>
